<template>
  <header>
    <!-- top header -->
    <div class="topHeader">
      <div class="full-col">
        <div class="topHeaderLeft">
          <ul class="inlineUl topNav">
            <li class="mobile-hidden"><span class="desktop-visible">{{localTranslation["WeTranslate"]}}</span> <span
                class="big">24/7</span> <span class="tablet-visible">{{localTranslation["Translation"]}}</span></li>
            <li><span class="tablet-hidden mobile-hidden">{{localTranslation["Support"]}}</span>&nbsp;<span class="big">855-500-2720</span></li>
          </ul>
        </div>
        <div class="topHeaderRight">
          <ul class="inlineUl topNav" v-if="accountData.CustomerType != 'guest'" @click="accountDropToggle($event)">
            <li class="accountDropdownLink"><a href="javascript:void(0)">{{accountData.Email}}</a>
              <div class="accountDropdown" :class="{'accountDropdownOpen' : accountDropShow}">
                  <div class="actionArrow"></div>
                  <div class="actionInfo">
                        <h4>{{accountData.FirstName}} {{accountData.LastName}}</h4>
                        <p>{{accountData.Email}}</p>
                        <h5>{{accountData.CustomerType}} {{localTranslation["customer"]}}</h5>
                    </div>
                    <div class="actionLinks">
                        <a href="http://translationpal.com/account/controlpanel" class="button buttonOrange left">{{localTranslation["ControlPanel"]}}</a>
                        <a href="http://translationpal.com/account/logout" class="button buttonGray right">{{localTranslation["Logout"]}}</a>
                        <div class="clearAll"></div>
                    </div>
                </div>
            </li>
          </ul>
          <ul class="inlineUl topNav" v-else>
            <li><a :href="'http://translationpal.com/account/login'">{{localTranslation["LoginRegister"]}}</a></li>
            <li><a :href="'http://translationpal.com/check-orders?locale='+locale">{{localTranslation["OrderStatus"]}}</a></li>
          </ul>
        </div>
        <div class="clearAll"></div>
      </div>
    </div>
    <!-- /top header -->
    
    <!-- main header -->
    <nav class="mainHeader">
      <div class="full-col">
        <a :href="'http://translationpal.com/?locale='+locale" class="logo" style="width:217px;height:23px;"><img
            src="https://translationpal.com/imgs/2015/translationpal-logo.png" alt="ProofreadingPal Logo"
            style="width:217px;height:23px;"></a>
        <a href="javascript:void(0)" @click.prevent="menuToggle($event)" :class="{'hamburgerMenuClose' : menuShow}" class="hamburgerMenu tablet-visible mobile-visible">
          <span>Menu</span>
        </a>
        <ul class="inlineUl mainNav desktop-visible" :class="{'mainNav-visible' : menuShow}">
          <li><a href="javascript:void(0)">{{ localTranslation['Services'] }}</a>
            <div class="doubleMenu">
              <ul>
                <li><a :href="'http://translationpal.com/certified?locale='+locale" style="font-size:15px;font-weight:bold;">{{ localTranslation['Certified Translation'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/academic-translation?locale='+locale">{{ localTranslation['Academic Document'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/adoption-document-translation?locale='+locale">{{ localTranslation['Adoption Document'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/birth-certificate-translation?locale='+locale">{{ localTranslation['Birth Certificate'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/book-translation?locale='+locale">{{ localTranslation['Book and Manuscript'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/business-document-translation?locale='+locale">{{ localTranslation['Business Documents'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/contract-translation?locale='+locale">{{ localTranslation['Contract'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/cover-letter-translation?locale='+locale">{{ localTranslation['Cover Letter'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/cv-translation?locale='+locale">{{ localTranslation['CV'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/death-certificate-translation?locale='+locale">{{ localTranslation['Death Certificate'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/diploma-translation?locale='+locale">{{ localTranslation['Diploma'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/divorce-paperwork-translation?locale='+locale">{{ localTranslation['Divorce Paperwork'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/employee-handbook-translation?locale='+locale">{{ localTranslation['Employee Handbook'] }}</a></li>
              </ul>
              <ul>
                <li><a :href="'http://translationpal.com/services/immunization-records-translation?locale='+locale">{{ localTranslation['Immunization Records'] }}</a>
                </li>
                <li><a :href="'http://translationpal.com/services/legal-document-translation?locale='+locale">{{ localTranslation['Legal Document'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/manual-translation?locale='+locale">{{ localTranslation['Manual'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/market-research-translation?locale='+locale">{{ localTranslation['Market Research'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/marriage-certificate-translation?locale='+locale">{{ localTranslation['Marriage Certificate'] }}</a>
                </li>
                <li><a :href="'http://translationpal.com/services/medical-records-translation?locale='+locale">{{ localTranslation['Medical Records'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/passport-translation?locale='+locale">{{ localTranslation['Passport'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/press-release-translation?locale='+locale">{{ localTranslation['Press Release'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/resume-translation?locale='+locale">{{ localTranslation['Resume'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/technical-document-translation?locale='+locale">{{ localTranslation['Technical Document'] }}</a>
                </li>
                <li><a :href="'http://translationpal.com/services/transcript-translation?locale='+locale">{{ localTranslation['Transcript'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/website-translation?locale='+locale">{{ localTranslation['Website'] }}</a></li>
                <li><a :href="'http://translationpal.com/services/english-proofreading?locale='+locale">{{ localTranslation['English Proofreading'] }}</a></li>
              </ul>
              <span class="clearAll"></span>
            </div>
          </li>
          <li><a :href="'http://translationpal.com/about-translationpal?locale='+locale">{{ localTranslation['About'] }}</a>
            <div>
              <ul>
                <li><a :href="'http://translationpal.com/about-translationpal?locale='+locale">{{ localTranslation['About TranslationPal'] }}</a></li>
                <li><a :href="'http://translationpal.com/satisfaction-guarantee?locale='+locale">{{ localTranslation['100% Satisfaction Guarantee'] }}</a></li>
                <li><a :href="'http://translationpal.com/translation-process?locale='+locale">{{ localTranslation['Our Translation Process'] }}</a></li>
                <li><a :href="'http://translationpal.com/about-translationpal#translators?locale='+locale">{{ localTranslation['Meet Our Translators'] }}</a></li>
                <li><a href="https://translationpal.com/blog/">{{ localTranslation['TranslationPal Blog'] }}</a></li>
              </ul>
            </div>
          </li>
          <li><a :href="'http://translationpal.com/faq?locale='+locale">{{ localTranslation['Frequent Questions'] }}</a></li>
          <li><a :href="'http://translationpal.com/pricing?locale='+locale">{{ localTranslation['Pricing'] }}</a></li>
          <li><a :href="'http://translationpal.com/customer-support?locale='+locale">{{ localTranslation['Customer Service'] }}</a>
            <div>
              <ul>
                <li><a :href="'http://translationpal.com/customer-support?locale='+locale">{{ localTranslation['Customer Service'] }}</a></li>
                <li><a :href="'http://translationpal.com/faq?locale='+locale">{{ localTranslation['Frequently Asked Questions'] }}</a></li>
                <li><a :href="'http://translationpal.com/translator-career-opportunities?locale='+locale">{{ localTranslation['Career Opportunities'] }}</a></li>
                <li><a :href="'http://translationpal.com/feedback?locale='+locale">{{ localTranslation['Feedback'] }}</a></li>
              </ul>
            </div>
          </li>
        </ul>
        <div class="clearAll"></div>
      </div>
    </nav>
    <!-- /main header -->

  </header>
</template>
<script setup>
import { ref } from 'vue'
const menuShow = ref(false);
const accountDropShow = ref(false);
const props = defineProps({
  accountData: Object,
  locale: String,
  localTranslation: Object
});
function menuToggle() {
  menuShow.value = !menuShow.value;
};
function accountDropToggle() {
  accountDropShow.value = !accountDropShow.value;
}
</script>

<style></style>